import {
  ORDER_RECEIPT_REQUEST,
  ORDER_RECEIPT_SUCCESS,
  ORDER_RECEIPT_FAILURE,
} from '../../actions/types';

import { createOrderReceipt } from './factories';

const initialState = {
  error: null,
  loading: false,
  order: {},
};

export default function receiptReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ORDER_RECEIPT_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case ORDER_RECEIPT_FAILURE:
      return {
        ...state,
        loading: false,
        error: {
          statusCode: action.status,
          message: action.message,
        },
      };
    case ORDER_RECEIPT_SUCCESS: {
      return {
        ...state,
        loading: false,
        order: createOrderReceipt(action.payload.order),
      };
    }
    default:
      return { ...state };
  }
}
